
import uri from 'urijs';


// helpers

const flat = val => val && [val].flat() || []
const first = val => Array.isArray(val) && val[0] || typeof val === 'string' && val || ''
const json = id => document.querySelector(id) && JSON.parse(document.querySelector(id).textContent) || null


// form/querystring data

const form = form => {
	return [].reduce.call(form.elements || [], (data, element) => {	
		if (!element.name) return data;
		if (element.type === 'checkbox' || element.type === 'radio') {
			if (data[element.name] === undefined) data[element.name] = []
			element.checked && element.value && data[element.name].push(element.value)
		} else {
			data[element.name] = element.value;
		}
		return data;
	}, {});
}

const query = (formEl) => {
	
	const params = formEl 
		? form(formEl) 
		: uri(location.href).search(true)

	return {
		search : params.search || '',
		jobType : flat(params['jobType[]']),
		location : flat(params['location[]']),
		sector : flat(params['sector[]']),
		subject : flat(params['subject[]']),
		programme : flat(params['programme[]']),
		orderBy : first(params['orderBy']),
	}
}


// api data

const createUrl = (baseUrl, data) => {

	const url = uri(baseUrl)

	for (let parameter of ['search', 'jobType', 'location', 'sector', 'subject', 'programme', 'orderBy']) {
		let val = data[parameter]
		if (typeof val === 'string' && val.length) {
			url.addQuery(parameter, val)
		}
		if (Array.isArray(val) && val.length) {
			url.addQuery(parameter + '[]', val)
		}
	}

	return url.toString();
}

const fetch = (url, callback = () => {}) => {
	if (!url) callback(null)
	const request = new XMLHttpRequest()

	request.addEventListener('readystatechange', event => {
		if (request.readyState !== 4) return
	    if (request.status == 200) return callback(JSON.parse(request.responseText))
		return callback(null)
	})
	
    request.open("GET", url, true)
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
    request.send(null)
}

const filtersCount = (filters, jobs = []) => {
	const store = {}

	const add = (type, val) => {
		if (store[type] === undefined) store[type] = {}
		if (store[type][val] === undefined) store[type][val] = 0
		store[type][val]++
	}

	jobs.forEach(job => {
		for (const filterName in filters) {
			const jobField = job[filterName] || null
			filters[filterName].forEach(option => {
				if (typeof jobField === 'string' && option === jobField) add(filterName, option)
				if (Array.isArray(jobField) && jobField.indexOf(option) > -1) add(filterName, option)
			})
		}
	})

	return store
}


// model

export const createSearchModel = (formEl = undefined) => {

	if (formEl && !(formEl instanceof HTMLFormElement)) 
		throw Error('object passed to createSearchModel is not a HTMLFormElement')

	const data = formEl ? query(formEl) : query()
	const { baseUrl, searchUrl } = json('#site-settings')
	const filters = json('#search-filters-json')
	const subscriptions = []

	const get = (key) => {
		if (key !== undefined) return data[key]
		return data
	}

	const set = (key, value, fetchRemote = true, triggeredBy = false) => {
		data[key] = value;
		updateSubscriptions({ key, value, data, triggeredBy })
		if (fetchRemote) getRemote(key)
		return data[key]
	}

	const updateSubscriptions = (obj) => subscriptions.map(fn => fn(obj))
	const subscribe = fn => (typeof fn === 'function') && subscriptions.push(fn) && true
	
	const getRemote = (triggerKey) => {
		set('loading', true, false)
		fetch(
			createUrl(baseUrl + '/api/jobs', data), 
			data => {
				set('jobs', data.data, false, triggerKey)
				set('loading', false, false)
			}
		)
	}
	
	return {
		set, 
		get, 
		subscribe,
		filters : () => filters, 
		filtersCount : () => filtersCount(filters, data.jobs || []),
		run : () => getRemote(),
		apiUrl : () => createUrl(baseUrl + '/api/jobs', data),
		searchUrl : () => createUrl(searchUrl.replace(/\/$/, ''), data)
	}
}


